import styled from 'styled-components';

const DisclaimerMessageContent = styled.div`
	max-width: 360px;
`;

export default DisclaimerMessageContent;